<template>
  <div class="container-fluid">
    <a href="" @click.prevent="generateReport">Download Task Reports</a>
    <app-table
        :id="tableId"
        :options="options"
        @action="getListAction"
    />
  </div>


</template>

<script>

import * as actions from "../../../Config/ApiUrl";
import CoreLibrary from "@/core/helpers/CoreLibrary";
import {TableHelpers} from "@Views/Demo/Tables/mixins/TableHelpers";
import {axiosPost, axiosGet} from "@/app/Helpers/AxiosHelper";

export default {
  extends: CoreLibrary,
  name: "TaskReport",
  mixins: [TableHelpers],
  data() {
    return {
      report_id: 0,
      preloader: false,
      tableId: "company-report",
      filteredData: {
        status: "",
      },
      search: "",
      rowData: {},
      showModal: false,
      options: {
        name: this.$t("tab_filter"),
        url: actions.COMPANY_REPORTS_DETAIL,
        datatableWrapper: false,
        tableShadow: false,
        showHeader: true,
        columns: [
          {
            title: this.$t("title"),
            type: "custom-html",
            key: "report_path",
            modifier: (value,row) => {
              var path = value == null ? '---' : `<a class="text-primary cursor-pointer" id="${row.id}"  @click.prevent=${this.myFunction(row)}>${this.$t(value)}</a>`;
              return path;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value, row) => {
              let ClassName = "warning";
              if (value === "completed") ClassName = `success`;
              else if (value === "inprogress") ClassName = `dark`;
              return `<span class="text-capitalize badge badge-sm badge-pill badge-${ClassName}">${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("create_time"),
            type: "custom-html",
            key: "create_time",
            modifier: (value) => {
              var date = moment(value).format("YYYY-MM-DD hh:mm");
              return `<span>${this.$t(date)}</span>`;
            },
          },
          {
            title: this.$t("update_time"),
            type: "custom-html",
            key: "update_time",
            modifier: (value) => {
              var date = value == null ? '---' : moment(value).format("YYYY-MM-DD hh:mm");
              return `<span>${this.$t(date)}</span>`;
            },
          },

        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
          {
            title: this.$t("delete"),
            icon: "delete",
            type: "none",
          },

        ],
        showFilter: false,
        // showSearch: true,
        showCount: true,
        // showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },

    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];

  },
  methods: {
    downloadPdf(path) {
      window.location.href = actions.COMPANY_REPORT_DOWNLOAD+'?path='+path;
    },
    myFunction(rowData){
            let doc = document.getElementById(rowData.id);
            if(doc){
                doc.addEventListener('click', () => {
                  this.downloadPdf(rowData.report_path);
                })
            }
        },
    async generateReport(){

      const url = window.location.href;
      const reportId = url.split("/").slice(-1)[0];
      this.preloader = true;

      axiosPost('/admin/company-reports/generate', {report_id:reportId, reportType:'Task'})
          .then((response) => {
            if (response.data.status == 200) {
                if (response.data.type == 'info') {
                  this.$toastr.i(response.data.message);
                  this.preloader = false;
                }
                else {
                  this.$toastr.s(response.data.message);
                  this.preloader = false;
                }         
            }
          })
          .catch((error, message) => {
            // Trigger after error
            console.log(error, message)

          })
          .finally(() => {
            this.loadDataTable();
          });

          this.loadDataTable();
    },

    loadDataTable() {
      this.options.url = actions.COMPANY_REPORTS_DETAIL+'?report_id='+this.report_id;
      let instance = this;
      setTimeout(function () {
        instance.$hub.$emit("reload-" + instance.tableId);
      },1000);
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      // if (actionObj.title == this.$t('view')) {
      //   this.view(rowData.id);
      // }
      // else if (actionObj.title == this.$t('payment'))
      // {
      //   if (rowData.status == 'succeeded')
      //   {
      //     this.$toastr.s('You are already paid customer');
      //   }
      //   else
      //   {
      //     window.location = '/admin/stripePay2/' + rowData.id;
      //   }

      // }

    },

},
  mounted() {
    const url = window.location.href;
    this.report_id = url.split("/").slice(-1)[0];
    this.options.url = actions.COMPANY_REPORTS_DETAIL+'?report_id='+this.report_id;

  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
